<template>
  <router-view></router-view>
</template>

<script>
import AuthService from './services/auth.service'
import eventbus from './util/eventbus'

export default {
  beforeMount() {
    AuthService.configureAxios()
    if (AuthService.isAuthenticated()) {
      AuthService.me()
    }
    eventbus.$on('on401', (ev) => {
      if (this.$router.currentRoute.name !== 'login') {
        this.$router.push({ name: 'login' })
      }
    })
  }
}
</script>
